<script lang="ts">
  import { Col } from "sveltestrap";
  import Card from "../Cardwidgets.svelte";
  import { sales } from "../../../Data/Chart/Widget/ChartPage/Chart";
  import { chart } from "svelte-apexcharts";
    import { SALE } from "../../../utils/Constant/Constant";
</script>

<Col xl="4">
  <Card
    cardprops="o-hidden"
    cardbodyprops="row"
    customCol="col-5"
    cardtitleprops="f-w-600 font-primary"
    cardtitle={SALE}
    cardvalue="90"
    customsubCol="col-7 text-end"
    cardsubprops="num total-value"
    cardsubvalue=".00"
    sign="$"
    countervalue="3654"
  >
    <div slot="customChart">
      <div id="chart-widget1">
        <div use:chart={sales} />
      </div>
    </div>
    ​
  </Card>
</Col>
